export const SET_PING = 'SET_PING';
export const SET_EXCHANGES = 'SET_EXCHANGES';
export const SET_COUNTRIES = 'SET_COUNTRIES';
export const SET_ASSOCIATIONS_STATES = 'SET_ASSOCIATIONS_STATES';
// Points of sale categories
export const SET_POINTS_OF_SALE_CATEGORIES = 'SET_POINTS_OF_SALE_CATEGORIES';
export const SET_IS_LOADING_POINTS_OF_SALE_CATEGORIES = 'SET_IS_LOADING_POINTS_OF_SALE_CATEGORIES';
export const SET_CATEGORY_SELECTED = 'SET_CATEGORY_SELECTED';
export const CREATE_CATEGORY = 'CREATE_CATEGORY';
export const IS_LOADING_CREATE_CATEGORY = 'IS_LOADING_CREATE_CATEGORY';
export const UPDATE_CATEGORY = 'UPDATE_CATEGORY';
export const IS_LOADING_UPDATE_CATEGORY = 'IS_LOADING_UPDATE_CATEGORY';
export const DELETE_CATEGORY = 'DELETE_CATEGORY';
export const IS_LOADING_DELETE_CATEGORY = 'IS_LOADING_DELETE_CATEGORY';
